<template>
  <nav>
    <div class="navbar navbar-expand-md navbar-light bg-light ">

      <div class="navbar-brand">
        <router-link :to="{path: '/'}">
          <cld-image publicId="logo" size="80px"/>
        </router-link>
      </div>

    </div>
    <div class="px-3 pb-1 bg-light">
      <search @select="$router.push({name: $event.type + 'Detail', params: {id: $event.id}})"/>
    </div>
  </nav>
</template>

<script>
import Search from "@/components/search/Search";

export default {
  components: {
    search: Search
  }
}
</script>
